const { client, loadToken } = require('./client');
export { loadToken };


export async function getAllGroups() {
  var { data } = await client.get(`/groups`);
  return data;
}

export async function getGroupWithID(id) {
  var { data } = await client.get(`/groups/${id}`);
  return data;
}

export async function getGroupWithDeviceUUID(uuid) {
  var { data } = await client.get(`/groups/device/${uuid}`);
  return data;
}

export async function getGroupDeviceUUIDSWithIDs(ids) {
  var { data } = await client.get(`/groups/getAllUUIDs/${ids.join(',')}`);
  return data;
}

export async function createGroup(data) {
  var { data } = await client.post(`/groups`, data);
  return data;
}

export async function updateGroup(id, group_data){
  var { data } = await client.put(`/groups/${id}`, group_data);
  return data;
}

export async function deleteDeviceGroup(group_id) {
  var { data } = await client.delete(`/groups/${group_id}`);
  return data;
}

export async function updateGroupDevicesConfig(group_id, device_data){
  var { data } = await client.put(`/groups/devices/${group_id}`, device_data);
  return data;
}

const all = {
  loadToken, getAllGroups, getGroupWithID, getGroupWithDeviceUUID, getGroupDeviceUUIDSWithIDs, createGroup, updateGroup, deleteDeviceGroup, updateGroupDevicesConfig
};

export default all;